export const loadScript = (uri: string) => {
  const script = document.createElement('script');
  // script.type = 'text/javascript';
  script.src = uri;

  return new Promise((resolve, reject) => {
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script);
    script.onload = () => resolve(script);
    script.onerror = e => reject(e);
  });
};
